/* import __COLOCATED_TEMPLATE__ from './reviewable-user.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import discourseComputed from "discourse-common/utils/decorators";
import TEMPLATE from "./reviewable-user.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend(dt7948.p({
  userFields(fields) {
    return this.site.collectUserFields(fields);
  }
}, [["method", "userFields", [discourseComputed("reviewable.user_fields")]]])));